export default __webpack_public_path__ + "static/Leon_Conrad-07863791ca8a19c3eaf60beae408aa7d.jpg";